<template>
    <v-layout row wrap class="component-text-size">
        <v-row class="vertical ma-0 pa-0 full-width" v-if="displayList.length === 0">
            <v-flex xs12 class="center-text">
                <v-icon size="100" class="mb-2">
                    mdi-file-question-outline
                </v-icon>
                <p>
                    No tasks found! Create a new task
                </p>
            </v-flex>
        </v-row>
        <v-flex v-else :class="(selected && selected.id) && `hide-list`" xs12>
            <v-layout row wrap class="task-list">
                <v-flex
                    xs12
                    :id="'taskList'"
                    class="p-3"
                    v-for="(jobTask, index) in displayList"
                    :key="index">
                    <v-card
                        :ripple="false" v-if="jobTask.status === 'Unassigned'" v-bind:class="selected && jobTask.id === selected.id ? 'pa-3 task-card card-selected' : 'pa-3 task-card'"
                        @click="selectJobTask(jobTask)">
                        <v-layout row wrap>
                            <v-flex xs7 class="font-weight-bold">
                                Task #{{ getJobTaskNumber(jobTask) }}
                            </v-flex>
                            <v-flex xs5 class="text-right grey-text">
                                {{ getRemainingDays(jobTask) }}
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs10 class="grey-text address card-address-line-height">{{chopAddress(jobTask.address) }}</v-flex>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-flex v-on="on" xs1>
                                        <v-icon
                                            v-bind:color="selected && jobTask.id === selected.id ? 'white' : 'success'"
                                            class="icon-location"
                                            @click="editJobTask(jobTask)">
                                            mdi-square-edit-outline
                                        </v-icon>
                                    </v-flex>
                                </template>
                                <span>Edit Task</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-flex v-on="on" xs1>
                                        <v-icon
                                            v-bind:color="selected && jobTask.id === selected.id ? 'white' : 'success'"
                                            class="icon-location"
                                            @click="completeJobTask(jobTask)">
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </v-flex>
                                </template>
                                <span>Complete Task</span>
                            </v-tooltip>
                        </v-layout>
                        <v-layout row wrap>
                            <v-chip-group
                                column
                                active-class="primary--text">
                                <v-chip disabled v-for="taskTag in jobTask.jobTaskTags" :key="taskTag.id">
                                    {{ (taskTag && taskTag.tag ? taskTag.tag.name : '')}}
                                </v-chip>
                            </v-chip-group>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
        <task-details :from-route-details="false" :toggle="toggleEditTask" :show-dialog="editTaskDialog"></task-details>
        <task-complete :toggle="toggleCompleteTask" :show-dialog="completeTaskDialog" :jobTask="jobTaskToComplete"></task-complete>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Helpers from  '@/utils/helpers/jobTaskHelpers'
    import TaskDetails from './Details'
    import TaskComplete from './Complete'
    export default {
        data: () => ({
            editTaskDialog: false,
            completeTaskDialog: false,
            jobTaskToEdit: {},
            selectedTask: null,
            jobTaskToComplete: {},
            displayList: []
        }),
        props: {
            updateTaskList : {
                type: Function,
                required: true
            }
        },
        methods: {
            ...mapActions({
                getTask: 'jobTasks/getById',
                selectTask: 'jobTasks/select',
                clearSelectedTask: 'jobTasks/clearSelected'
            }),
            selectJobTask(jobTask) {
                this.getTask(jobTask.id)
            },
            getRemainingDays(jobTask) {
                let d = new Date()
                let messageDate = new Date(jobTask.dueDate)
                let dayDiff = Math.ceil((messageDate - d) / (1000 * 60 * 60 * 24))
                if (dayDiff > 0) {
                    return `${dayDiff} days`
                } else if (dayDiff === 0) {
                    return 'Today'
                } else {
                    return 'Overdue'
                }
            },
            getJobTaskNumber (jobTask) {
                return jobTask.taskNumber
            },
            async editJobTask(jobTask) {
                this.selectedTask = jobTask
                await this.getTask(jobTask.id)
                await this.toggleEditTask()
            },
            completeJobTask(jobTask) {
                this.jobTaskToComplete = jobTask
                this.toggleCompleteTask()
            },
            toggleEditTask () {
                if(this.editTaskDialog){
                    this.updateTaskList()
                    if(this.selected.routeId != null){
                        this.clearSelectedTask()
                    }
                }
                this.editTaskDialog = !(this.editTaskDialog)
            },
            toggleCompleteTask () {
                if(this.completeTaskDialog){
                    this.updateTaskList()
                }
                this.completeTaskDialog = !(this.completeTaskDialog)
            },
            chopAddress(address) {
                return Helpers.chopAddress(address)
            },
            showSelectedTask(task){
                //if the selected task is in the raw list, remove it
                this.displayList = this.taskRange.filter(jt => {
                   return jt.id !== task.id
                })
                //Regardless, put selected task on top
                this.displayList.unshift(task)
            }
        },
        components: {
            TaskDetails,
            TaskComplete
        },
        created() {
            this.clearSelectedTask();
        },
        watch: {
            selected(newVal) {
               if(newVal && newVal.id){
                   //if its in our display list, go to it
                   if(this.displayList.some(jt => jt.id === newVal.id)){
                       location.href = `#${newVal.id}`
                       return
                   }
                   //else put it on top and go to it
                   this.showSelectedTask(newVal)
                   setTimeout(function() {
                       const el = document.getElementById(newVal.id.toString())
                       if(el) {
                           el.scrollIntoView();
                       }
                   }, 50);
               }
            },
            taskRange(tasks) {
                if(this.selected){
                    this.showSelectedTask(this.selected)
                } else {
                    this.displayList = tasks
                }
            }
        },
        computed: {
            ...mapGetters({
                taskRange: 'jobTasks/activeTaskRange',
                selected: 'jobTasks/selectedJobTask'
            }),
        }
    }
</script>

<style>
    .card-address-line-height{
        line-height: 1.3;
    }
    .icon-location{
        float:right;
    }
    .center-text{
        text-align: center;
    }
    .full-width {
        width: 100%;
    }
    .component-text-size {
        font-size:15px
    }
    .task-list .grey-text {
        color: #b1b0b0;
    }

    .task-list .card-selected .grey-text {
        color: #ffffff;
    }

    .task-list .card-selected {
        background-color: #44DAA5;
        color: #ffffff;
    }

    .task-list .card-flagged .grey-text {
        background-color: #ff5b5b !important;
        color: #ffffff;
    }

    .task-list {
        height: 100%;
        padding: 8px 0;
    }

    .task-list .task-card:hover {
        cursor: pointer;
        position: relative;
    }

    .vertical {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70vh;
    }

</style>
